import React, { useContext } from 'react';
import { NavMenu } from './navbarStyle';
import { Link, useLocation } from 'react-router-dom';
import linkedinImg from '../../assets/icons/linkedin.svg';
import githubImg from '../../assets/icons/github.svg';
import twitterImg from '../../assets/icons/twitter.svg';
import AgbaContext from '../../context/agba/agbaContext';
import { AstroBtn, Bubble } from '../../utils/customStyles';

const Navbar = () => {
  const agbaContext = useContext(AgbaContext);
  const { openNav, closeNav, sideBar } = agbaContext;

  const location = useLocation();

  const pathName = (route) => {
    if (route === location.pathname) {
      return true;
    } else {
      return false;
    }
  };

  const handleOnClick = () => {
    if (sideBar) {
      closeNav();
    } else {
      openNav();
    }
  };

  return (
    <NavMenu navState={sideBar}>
      <div className='logo'>
        <Link to='/'>
          <h1>&lt;A&#47;&gt;</h1>
        </Link>
      </div>
      <div className='navBtn-check'>
        <div className='navBtn' onClick={handleOnClick}>
          <div className='hamburger-menu'></div>
        </div>
      </div>
      <div className='overlay'>
        <div className='side-bar'>
          <div className='home-text'>{/* <p>Home</p> */}</div>
          <ul className='overlay-card'>
            <li
              className='link-item'
              onClick={handleOnClick}
              style={{
                'border-color': pathName('/about') ? '#3bcfe3' : '#023047',
              }}
            >
              <Link
                to='/about'
                style={{
                  color: pathName('/about') ? '#3bcfe3' : '#fff',
                }}
              >
                <p>About</p>
              </Link>
            </li>
            <li
              className='link-item'
              onClick={handleOnClick}
              style={{
                'border-color': pathName('/skill') ? '#3bcfe3' : '#023047',
              }}
            >
              <Link
                to='/skill'
                style={{
                  color: pathName('/skill') ? '#3bcfe3' : '#fff',
                }}
              >
                <p>My Skills</p>
              </Link>
            </li>
            <li
              className='link-item'
              onClick={handleOnClick}
              style={{
                'border-color': pathName('/portfolio') ? '#3bcfe3' : '#023047',
              }}
            >
              <Link
                to='/portfolio'
                style={{
                  color: pathName('/portfolio') ? '#3bcfe3' : '#fff',
                }}
              >
                <p>Portfolio</p>
              </Link>
            </li>
            <li
              className='link-item'
              onClick={handleOnClick}
              style={{
                'border-color': pathName('/blog') ? '#3bcfe3' : '#023047',
              }}
            >
              <Link
                to='/blog'
                style={{
                  color: pathName('/blog') ? '#3bcfe3' : '#fff',
                }}
              >
                <p>Blog</p>
              </Link>
            </li>
            <li
              className='link-item'
              onClick={handleOnClick}
              style={{
                'border-color': pathName('/contact') ? '#3bcfe3' : '#023047',
              }}
            >
              <Link
                to='/contact'
                style={{
                  color: pathName('/contact') ? '#3bcfe3' : '#fff',
                }}
              >
                <p>Contact</p>
              </Link>
            </li>
          </ul>
          <ul className='nav-icons'>
            <li className='icon-item'>
              <a
                href='https://www.linkedin.com/in/emmanuel-agba'
                className='icon-link'
              >
                <img src={linkedinImg} alt='LinkedIn' />
              </a>
            </li>
            <li className='icon-item'>
              <a href='https://github.com/tracemycodes' className='icon-link'>
                <img src={githubImg} alt='github' />
              </a>
            </li>
            <li className='icon-item'>
              <a href='https://twitter.com/trace_it' className='icon-link'>
                <img src={twitterImg} alt='twitter' />
              </a>
            </li>
          </ul>

          <AstroBtn>
            <a
              href='https://drive.google.com/file/d/1rOWVzjDYBL888n1iS0NZ8PEWkcEXww4U/view?usp=sharing'
              target='blank'
              className='resume-link'
            >
              Resume
            </a>
            <Bubble count={1}></Bubble>
            <Bubble count={2}></Bubble>
            <Bubble count={3}></Bubble>
            <Bubble count={4}></Bubble>
          </AstroBtn>
        </div>
      </div>
    </NavMenu>
  );
};

export default Navbar;
